import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleAnalisisCasoParticular = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleAnalisisCasoParticular/tarea-detalle-analisis-caso-particular"
    )
);
export function tareaDetalleAnalisisCasoParticular() {
  return (
    <Route
      path="/tarea-detalle-analisis-caso-particular"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleAnalisisCasoParticular />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
